import {Application} from "./Application";
import {PageHelper} from "./PageHelper";
import {NullMessages} from "./localization/NullMessages";
import {NullCommonPage} from "./NullCommonPage";
import {NullDataChannel} from "./controller/NullDataChannel";
import type {CommonPage} from "./CommonPage";
import type {Messages} from "./localization/Messages";
import type {DataChannel} from "./controller/DataChannel";

//
// Note that this will be run on pages without a page header, so it has to work
// even if there isn't page header data available.
//
// WARNING: Avoid putting logic in here that ties together all the bits of the application
//          otherwise, we'll likely have problems with unit tests, at least until
//          we can eliminate jQuery. Unfortunately this is counter-intuitive and not ideal.
//
export class ExclaimApplication implements Application {
    readonly ph = new PageHelper();

    readonly locale: string = this.ph.locale;
    readonly language: string = this.ph.lang;
    readonly isEdjuster = this.ph.getHeaderBoolean('isEdjuster', false);

    // Populated with trivial placeholders to start; common page will populate during init
    // (this is largely to support unit testing and pages that do not need all objects).
    Messages: Messages = new NullMessages();
    commonPage: CommonPage = new NullCommonPage();
    dataChannel: DataChannel = new NullDataChannel();
}
